import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";

import Tooltip from "../Tooltip";

export default function ExternalRefIdHelpAdornment() {
  return (
    <Tooltip
      placement="top"
      title="This (optional) id is intended to help you cross reference TrueBiz alerts with entities in your system. It will be included in all api responses related to this monitor."
    >
      <HelpOutlineOutlinedIcon
        fontSize="small"
        color="primary"
        style={{ cursor: "default" }}
      />
    </Tooltip>
  );
}
